//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"BlendCurveOption",1,0],[1,"CornerFillet",0,"ScCollector",0],[1,"CurveBlend",0,"ScCollector",0],[0,"DistanceTolerance",1,0],[0,"InputCurves",1,0],[0,"MinimalRadius",1,0],[0,"ReferenceDirection",1,"Direction",0],[0,"ReverseSide",1,0]],[[[],"SaveFilletCurves",{},0,0],[["numberCurves"],"CreateBlendCurves",{R_:{blendCurves:"Curve[]"}},0,0],[["blendCurves"],"DeleteBlendCurves",{},1,0]],[]];
SPLM.Tooling.BlendCurve3DBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BlendCurve3DBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BlendCurve3DBuilder.BlendCurveOptions = Object.freeze({
    "BestFit" : "BestFit", "Variable" : "Variable", "Vector" : "Vector", "CurrentView" : "CurrentView"});

SPLM.Tooling.BlendCurve3DBuilder.InputCurvesOption = Object.freeze({
    "Keep" : "Keep", "Hide" : "Hide", "Delete" : "Delete"});

export default SPLM;